<template>
  <div class="case">
    <banner :img="bannerImg" title="精典案例" />
    <div class="navbar">
      <div
        class="navbar-item"
        @click="active = 1"
        :class="{ isActive: active == 1 }"
      >
        <div style="margin-top:10px">
          <img
            style="width:50px"
            src="../assets/img/aboutUs/about1.png"
            alt=""
          />
        </div>
        <div>公司介绍</div>
      </div>
      <div
        class="navbar-item"
        @click="active = 2"
        :class="{ isActive: active == 2 }"
      >
        <div style="margin-top:10px">
          <img
            style="width:50px"
            src="../assets/img/aboutUs/about2.png"
            alt=""
          />
        </div>
        <div>荣誉资质</div>
      </div>
      <div
        class="navbar-item"
        @click="active = 3"
        :class="{ isActive: active == 3 }"
      >
        <div style="margin-top:10px">
          <img
            style="width:50px"
            src="../assets/img/aboutUs/about3.png"
            alt=""
          />
        </div>
        <div>公司资讯</div>
      </div>
    </div>
    <div class="aboutUs" v-if="active == 1">
      <div class="box-solgan">
        始终以“让数据价值流动起来”为愿景，通过技术与AI服务双轮驱动，赋能千行百业数字化转型。
      </div>
      <div class="flex-s">
        <div class="left">
          <div>
            中启联信科技集团有限公司成立于2019年，总部位于福建省福州市，是国家级高新技术企业、国家科技型中小企业，以<span
              style="color:#7caefb"
              >“让数据成为资产，让AI创造效益”</span
            >为核心使命，致力于成为数据要素全生命周期管理与AI技术落地的行业引领者。
          </div>
          <div class="left-1">核心定位与资质</div>
          <div class="left-2">
            <span style="color:#7caefb;font-weight:bold;">国家级双认证：</span
            >国家高新技术企业、国家科技型中小企业
          </div>
          <div class="left-2">
            <span style="color:#7caefb;font-weight:bold;">行业标准引领者：</span
            >国家数据标准化委员会成员单位，推动数据治理合规化、标准化
          </div>
          <div class="left-2">
            <span style="color:#7caefb;font-weight:bold;">数据服务先锋：</span
            >首批福建大数据交易所、江西省数据交易平台官方服务商，实现数据资产流通交易合规化
          </div>
        </div>
        <div class="right">
          <img style="width:100%" src="../assets/img/aboutUs/tp2.png" alt="" />
          <img style="width:100%" src="../assets/img/aboutUs/tp1.png" alt="" />
        </div>
      </div>
    </div>
    <div class="box2" v-if="active == 1">
      <div class="box-title1">业务全景</div>
      <div class="flex-ss">
        <div class="active_item item1">
          <div class="text1">1. 数据价值化</div>
          <div class="text2">
            数据监测平台 | 数据资产入表服务 | 数据交易服务
          </div>
          <div class="text3">
            通过“数据雪球理论”助力政企实现数据资产持续增值，完成成本分摊与财务核算优化
          </div>
        </div>
        <div class="active_item item2">
          <div class="text1">2. AI全链开发</div>
          <div class="text2">高精度数据标注 | AI模型训练 | 智能体构建</div>
          <div class="text3">
            覆盖智能制造、智慧城市等领域，提供算法开发与场景化AI解决方案
          </div>
        </div>
        <div class="active_item item3">
          <div class="text1">3. AI企业级落地</div>
          <div class="text2">私域部署 | 智能化场景应用 | 数字化转型方案</div>
          <div class="text3">
            服务国企、央企及上市公司，实现降本增效与精准决策
          </div>
        </div>
      </div>
    </div>
    <div class="box1" v-if="active == 1">
      <div class="box-title">服务理念</div>
      <ul style="display: flex;justify-content: space-between;">
        <li class="box1-item" v-for="(item, index) in lists" :key="index">
          <div style="padding: 30px;position: relative;z-index: 2;">
            <h3 style="font-size: 24px;font-weight: bold;">
              {{ item.title }}
            </h3>
            <div
              style="display: block;width: 62px;height: 4px;border-radius: 5px;background: #7caefb;margin-top: 10px;margin-bottom: 15px;"
            ></div>
            <div style="font-size: 20px;line-height: 1.4;">
              {{ item.content }}
            </div>
          </div>
          <span
            style="display: block;position: absolute;right: 0;bottom: -10px;width: 234px;"
          >
            <img :src="item.img" />
          </span>
        </li>
      </ul>
    </div>
    <div class="box3" v-if="active == 2">
      <div class="box-title">企业荣誉</div>
      <div class="box-flex">
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/1.png" />
          <div>AAA级信用企业</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/2.png" />
          <div>AAA级信用等级</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/3.png" />
          <div>创新价值企业（团队）</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/4.png" />
          <div>大数据信息技术服务企业资质证书一级</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/5.png" />
          <div>大数据信息技术服务企业资质证书一级</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/6.png" />
          <div>福建省信息产业商会副会长单位</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/7.png" />
          <div>公共数据授权运营合规要求团体标准特邀起草单位</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/8.png" />
          <div>科技型中小企业</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/qyry/9.png" />
          <div>科技型中小企业</div>
        </div>
      </div>
    </div>
    <div class="box3" v-if="active == 2">
      <div class="box-title">ISO认证</div>
      <div class="box-flex">
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/iso/1.png" />
          <!-- <div>AAA级信用企业</div> -->
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/iso/2.png" />
          <!-- <div>AAA级信用等级</div> -->
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/iso/5.png" />
          <!-- <div>大数据信息技术服务企业资质证书一级</div> -->
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/iso/6.png" />
          <!-- <div>福建省信息产业商会副会长单位</div> -->
        </div>
      </div>
    </div>
    <div class="box3" v-if="active == 2">
      <div class="box-title">软件著作权资质</div>
      <div class="box-flex">
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/1.jpg" />
          <div>宠物数据融合应用平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/2.jpg" />
          <div>大数据存储优化解决方案软件</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/3.jpg" />
          <div>大数据可视化分析系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/4.jpg" />
          <div>大数据清洗与预处理平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/5.jpg" />
          <div>大数据实时分析引擎系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/6.jpg" />
          <div>大数据物联网集成平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/7.jpg" />
          <div>大数据行业应用解决方案系统（医疗版）</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/8.jpg" />
          <div>大数据行业应用解决方案系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/9.jpg" />
          <div>大数据智能采集系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/10.jpg" />
          <div>大数据智能运维平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/11.jpg" />
          <div>基于多维数据挖掘的大数据精准分析创新平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/12.jpg" />
          <div>全网舆情捕捉评估系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/13.jpg" />
          <div>人工智能模型评估平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/14.jpg" />
          <div>人工智能数据标注工具管理系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/15.jpg" />
          <div>信速察网络信息安全管理平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/16.jpg" />
          <div>信速察舆情大数据监测平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/17.jpg" />
          <div>一种融合智能算法的大数据高效处理系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/18.jpg" />
          <div>中启联信公共数据运营服务平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/19.jpg" />
          <div>中启联信品牌声誉数据感知系统</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/20.jpg" />
          <div>中启联信数据资产管理平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/21.jpg" />
          <div>中启联信智检分析和内容管理平台</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/rjzz/22.jpg" />
          <div>中启联信智能校对和新媒体管理系统</div>
        </div>
      </div>
    </div>
    <div class="box3" v-if="active == 2">
      <div class="box-title">合作单位</div>
      <div class="box-flex">
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/1.png" />
          <div>安徽省大数据交易所</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/2.png" />
          <div>福建大数据交易所数商证书</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/3.png" />
          <div>广州数据交易所会员证</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/4.png" />
          <div>贵阳大数据数商凭证</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/5.png" />
          <div>湖南大数据交易数据经纪商</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/6.png" />
          <div>湖南大数据交易所VIP服务会员</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/7.png" />
          <div>开放群岛开源社区</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/8.png" />
          <div>深圳数据交易所数据商纪念证书</div>
        </div>
        <div class="box-flex-item">
          <img src="../assets/img/aboutUs/hzdw/9.png" />
          <div>西部数据交易中心数商证书</div>
        </div>
      </div>
    </div>
    <div class="box4" v-if="active == 3">
      <div class="box-flex">
        <div class="left">
          <el-carousel indicator-position="outside" height="350px">
            <el-carousel-item v-for="(item, index) in newList" :key="index">
              <img style="width: 100%;" :src="item.img" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="right">
          <div
            style="display: flex;border-bottom: 1px solid #e0e0e0;padding: 20px;cursor: pointer;"
            v-for="(item, index) in newList"
            :key="index"
            @click="changeUrl(item)"
          >
            <div class="time">
              <div class="day">{{ item.day }}</div>
              <div class="month">{{ item.month }}</div>
            </div>
            <div class="content">
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="more" @click="$router.push('/moreNews')">查看更多</div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
import newList  from "./data";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      newList: newList.slice(0,3),
      active: 1,
      lists: [
        {
          title: "数据价值化",
          content:
            "想客户所想，急客户所急，保障故障处理时效，快速响应客户需求。",
          img: require("../assets/img/case/item1.png"),
        },
        {
          title: "品质",
          content:
            "从客户角度出发，关注客户需求，致力于为客户提供更好的用户体验。",
          img: require("../assets/img/case/item2.png"),
        },
        {
          title: "价值",
          content:
            "以客户为导向的价值管理、价值创新、价值研究的工作与思维模式，减少业务中断概率。",
          img: require("../assets/img/case/item3.png"),
        },
        {
          title: "责任",
          content: "尊重客户，站在客户的角度看问题，尽全力满足客户需求。",
          img: require("../assets/img/case/item4.png"),
        },
      ],
      bannerImg: require("../assets/img/aboutUs/banner.png"),
      loading: true,
      caseList: [],
    };
  },
  mounted() {
    if (this.$route.query.index == 3) {
      this.active = 3;
    }
    window.console.log("case");
  },
  methods: {
    changeUrl(item) {
      window.open(item.url);
    },
  },
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  .navbar {
    z-index: 90;
    width: 1200px;
    height: 100px;
    position: absolute;
    left: 50%;
    top: 450px;
    margin-left: -600px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    flex-wrap: nowrap;
    box-shadow: 2px 6px 26px 0 rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 6px;
    background: #f6f9ff;
    .navbar-item {
      height: 100px;
      width: calc(100% / 3);
      text-align: center;
      cursor: pointer;
    }
    .isActive {
      color: #3a4354;
      background: #fff;
    }
  }
  .more{
    text-align: center;
    margin-top: 30px;
    cursor: pointer;
    &:hover{
      color: #1266ec;
    }
  }
  .box4 {
    width: 1400px;
    margin: 100px auto;
    .box-flex {
      display: flex;
      .left {
        width: 48%;
        margin-right: 40px;
      }
      .right {
        width: 48%;
        .content {
          flex-shrink: 0;
          margin-left: 10px;
          .title {
            font-size: 18px;
            width: 540px;
          }
          .text {
            margin-top: 8px;
            color: #686868;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            width: 540px;
          }
        }

        .time {
          flex-shrink: 0;
          text-align: center;
          .day {
            font-size: 32px;
            font-weight: bold;
            color: #3a4354;
          }
          .month {
            margin-top: 10px;
            font-size: 20px;
            color: #3a4354;
          }
        }
      }
    }
  }
  .box3 {
    width: 1400px;
    margin: 100px auto;
    .box-flex {
      display: flex;
      flex-wrap: wrap;
      .box-flex-item {
        flex-shrink: 0;
        width: 240px;
        height: 300px;
        text-align: center;
        margin: 0 20px;
        img {
          width: 100%;
          height: 240px;
          object-fit: scale-down;
        }
      }
    }
  }
  .box2 {
    .box-title1 {
      width: 1400px;
      margin: 40px auto 20px;
      font-size: 28px;
      color: #1266ec;
      font-weight: bold;
    }
    .flex-ss {
      width: 1400px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .box2-item {
        width: calc(100% / 3);
        height: 350px;
        padding: 0 26px 50px 24px;
        box-sizing: border-box;
        background: #fff;
        position: relative;
      }
      .active_item {
        .text1 {
          color: #fff;
          font-size: 24px;
          margin-bottom: 40px;
        }
        .text2 {
          color: #fff;
          font-size: 18px;
          margin-bottom: 30px;
        }
        .text3 {
          color: #fff;
          font-size: 14px;
        }
        width: calc(100% / 3);
        height: 440px;
        background-size: 100% 100%;
        padding: 30px 26px 50px 24px;
        box-sizing: border-box;
        background-repeat: no-repeat;
        position: relative;
      }
      .item1 {
        background-image: url("../assets/img/aboutUs/item1.png");
      }
      .item2 {
        background-image: url("../assets/img/aboutUs/item2.png");
      }
      .item3 {
        background-image: url("../assets/img/aboutUs/item3.png");
      }
    }
  }
  .aboutUs {
    width: 1400px;
    margin: 0 auto;
    .box-title1 {
      width: 1400px;
      margin: 40px auto 20px;
      font-size: 28px;
      color: #1266ec;
      font-weight: bold;
    }
    .box-solgan {
      font-size: 28px;
      text-align: center;
      font-weight: bold;
      justify-content: space-between;
    }
    .flex-s {
      display: flex;
      justify-content: space-between;
      .left {
        margin-top: 40px;
        width: 60%;
        font-size: 24px;
        .left-1 {
          margin-top: 20px;
          color: #000;
          font-weight: bold;
        }
        .left-2 {
          margin-top: 20px;
        }
      }
      .right {
        margin-top: 40px;
        width: 35%;
      }
    }
  }
  .box1 {
    width: 1400px;
    margin: 20px auto;
    .box1-item {
      width: calc((100% - 20px * 3) / 4);
      position: relative;
      background: #f7f8f8;
      border-radius: 10px;
      overflow: hidden;
      padding-bottom: 120px;
      &:hover {
        background: rgba(#1266ec, 0.8);
        color: #fff !important;
      }
    }
  }
  .box-title {
    font-size: 28px;
    color: #1266ec;
    font-weight: bold;
    margin: 40px 0 20px 0;
  }
  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>
